import { startOfQuarter, endOfQuarter } from 'date-fns';

export const getCurrentQuarter = (now = new Date()): DateRange => ({
    start: startOfQuarter(now),
    end: endOfQuarter(now),
});
